import { ActionResult } from 'common/constants';

export const selectUpdateAdditionalInfoLoading = state =>
  state.getIn(['newPerson', 'additionalInfo', 'updateAdditionalInfoLoading']);
export const selectAdditionalInfoForUpdateResult = (state): ActionResult =>
  state.getIn(['newPerson', 'additionalInfo', 'updateAdditionalInfoResult']);
export const selectAdditionalInfoLoading = state =>
  state.getIn(['newPerson', 'additionalInfo', 'additionalInfoLoading']);
export const selectAdditionalInfo = state => state.getIn(['newPerson', 'additionalInfo', 'result']);
